import type { RefObject } from 'react';

import SelectModal from '@/components/Select/SelectModal';
import type { SelectOptionT } from '@/components/Select/types';
import type { STRUCTURED_FILTER_OPERATOR } from '@/types/structuredFilterConst';

type Props = {
  dropdownKey: string;
  selected: STRUCTURED_FILTER_OPERATOR;
  hasMultiValues: boolean;
  isMultiValueField?: boolean;
  onChange?: (value: STRUCTURED_FILTER_OPERATOR) => void;
  anchorRef: RefObject<HTMLDivElement>;
  options: SelectOptionT[];
};

const FilterItemOperatorSelectModal = (props: Props) => {
  return (
    <SelectModal
      anchorRef={props.anchorRef}
      name={props.dropdownKey}
      data={() => ({
        list: props.options,
        cursor: null,
      })}
      value={props.selected}
      onSelect={(v) => props.onChange?.(v as STRUCTURED_FILTER_OPERATOR)}
      width="160px"
      modalOptions={{
        offset: {
          y: 4,
        },
      }}
    />
  );
};

export default FilterItemOperatorSelectModal;
